/**
 * Created by LENOVO T440 on 27/09/2017.
 */




(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('updateSectionController', updateSectionController);

    /* @ngInject */
    function updateSectionController($scope,modalModel,queryservice,sessionServices,obtGalleryService,$stateParams,languageServices,dataservice,$timeout) {
      loadComboBox()
      .then(setOptions)
      .then(setLanguage);
      $scope.getGalleryForDirective = getGalleryForDirective ;
      $scope.notifyMsg = notifyMsg
      $scope.galeryTamp = [];
      $scope.options = [];
      $scope.languageKey = {} ;
      $scope.updateGalleryData = updateGalleryData;
      console.log(sessionServices.getSession(), 'mes donnees ');
      $scope.model = modalModel ;
      $scope.currentSession = sessionServices.getSession();
      $scope.updateData = updateData ;
        //function closeModalOrShowAlert(data){
        //    if(data && (!data.error || data.error === 0)){
        //        vm.login={}; /*email, password, remember*/
        //        $uibModalInstance.close({error: 0, message: "Connected"});
        //    }else{
        //        vm.alert = data ? data.body : 'empty response received';
        //    }
        //    return data;
        //}
        function setgalleryTamp (data){
            $scope.galeryTamp = data ;
        }



          // angular.forEach(response,function(values){
          //
          //
          // })
          function  getGalleryForDirective (){
                var args = {uId:sessionServices.getSession().uId , galleryId :modalModel.data.galleryId};
                obtGalleryService.getItems(args).
                 then(function (response){
                   return response ;
                 })
                }
        function  getGallery (){
              var args = {uId:sessionServices.getSession().uId , galleryId :modalModel.data.galleryId};
              obtGalleryService.getItems(args).
               then(function (response){
                 UpdateGallery(response,$scope.model.data.gallery)
               })
              }
              function helpUpdateGalleryType7_9(serveur,client,direction){
                  if(direction === 'serveur'){
                    angular.forEach(serveur,function(value,key){
                          angular.forEach($scope.model.data.gallery,function(values,keys){
                                  if(value.galleryItemId === values.galleryItemId){
                                          value.thumbUrl = values.thumbUrl ;
                                          value.url = values.url ;
                                              angular.forEach(values.details,function(valueDetail,keyDetail){
                                                if(valueDetail.localeId === $scope.languageKey){
                                                  valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
                                                   valueDetail.description = values.description;
                                       }
                                             })

                                    }

                          })
                     })


                  }
               }
              function helpUpdateGalleryType4(serveur,client,direction){
                if(direction === 'serveur'){
                  angular.forEach(serveur,function(value,key){
                        angular.forEach($scope.model.data.gallery,function(values,keys){
                                if(value.galleryItemId === values.galleryItemId){
                                        value.thumbUrl = value.url = values.bgImg ;
                                            angular.forEach(values.details,function(valueDetail,keyDetail){
                                              if(valueDetail.localeId === $scope.languageKey){
                                                valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
                                                 valueDetail.description = values.description;
                                     }
                                           })

                                  }

                        })
                   })


                }
             }
              function helpUpdateGalleryType8(serveur,client,direction){
                 if(direction === 'serveur'){
                   angular.forEach(serveur,function(value,key){
                         angular.forEach($scope.model.data.gallery,function(values,keys){
                                 if(value.galleryItemId === values.galleryItemId){
                                         value.thumbUrl = value.url = values.avatar ;
                                             angular.forEach(values.details,function(valueDetail,keyDetail){
                                               if(valueDetail.localeId === $scope.languageKey){
                                             valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
                                              valueDetail.description = values.description;
                                      }
                                            })

                                   }

                         })
                    })


                 }
              }
// function UpdateGallery(serveur,client){
//   switch (modalModel.type) {
//   case "7":
//      console.log("type7");
//      console.log(client,'client');
//      console.log(serveur,'serveur');
//      helpUpdateGalleryType7_9(serveur,client,'serveur');
//     console.log('after',serveur);
//     break;
//   case "8":
//     console.log("type8");
//     console.log(client,'client');
//     console.log(serveur,'serveur');
//     helpUpdateGalleryType8(serveur,client,'serveur');
//       console.log('after',serveur);
//     break;
//   case "4":
//     console.log("type4");
//     console.log(client,'client');
//     console.log(serveur,'serveur');
//     helpUpdateGalleryType4(serveur,client,'serveur');
//     console.log('after',serveur);
//     break;
//   case "9":
//     console.log("type9");
//     console.log(client,'client');
//     console.log(serveur,'serveur');
//     helpUpdateGalleryType7_9(serveur,client,'serveur');
//       console.log('after',serveur);
//     break;
//   default:
//     console.log("Désolé, nous n'avons pas de gallery.");
//
// }
//
//
// return $scope.notifyMsg(
//   obtGalleryService.updateItem(serveur)
//   .then(function (response) {
//       console.log('update done');
//       console.log(response);
//       return response;
//   })
// );
//
// }

function updateGalleryData(){
  console.log($scope.model,'my newModalModel');
  console.log(modalModel,'my newModalModel');

}
function notifyMsg(promise){
    if(promise) {
        promise.then(function success(response) {
            if (response && response.error && response.error == 1) {
                toaster.pop('error', '', response.body);
            } else {
                toaster.pop('success', translateFilter('SUCCESS'), response.body);
            }
        });
    }
    return promise;
}
function  updateData(){
if(modalModel.type === '4' || modalModel.type === '7' || modalModel.type === '8' || modalModel.type === '9' ){
  getGallery() ;
}
else {
  alert('pas de gLLERU');
}
//  console.log($scope.model,'my modelData');
}
        function setOptions(options){
            $scope.options = options;
            return options ;
        }
        function setLanguage(options){
          console.log(options,'my options');
              $scope.languageKey = dataservice.form.findOptionNamePerCODE(sessionServices.getSession().language,options.languages);
        }
        function loadComboBox(params) {
            var cbIdList = params || [
                    {'id': 7, 'name': 'languages'},
                    {'id': 30, 'name': 'types'},
                    {'id': 31, 'name': 'shapes'},
                    {'id': 64, 'name': 'csss'},
                    {'id': 69, 'name': 'sizes'},
                    {'id': 71 ,'name': 'items'},
                    {'id': 92 ,'name': 'boxs'},
                    {'id': 93 ,'name': 'fuls'},
                    {'id': 80 ,'name': 'buttonTypes'},
                    {'id': 9, 'name': 'worktypes'}
                ];
            return queryservice.getFormOptions(cbIdList, undefined, undefined, {isTool: true}).then(
                function success(result) {
                  console.log(result,'advisor');
                    return result;
                }
              )
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/login/updateSectionForms/updateSectionCtrl.js
 ** module id = 230
 ** module chunks = 0
 **/